<div class="subHeader px-4 py-2 w-full text-center text-xl font-semibold text-ink-700">
  <h2>{{ text }}</h2>
</div>
